"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderPicture = void 0;
var _propTypes = require("prop-types");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {string} src
 * @param {{'1x': string, '2x': string}} sizing
 * @returns {string}
 */
const createSrcSet = (src, sizing) => {
  return Object.entries(sizing).map(_ref => {
    let [key, value] = _ref;
    return "".concat(src, "?").concat(value, " ").concat(key);
  }).join(", ");
};
const calculateAspectRatio = (width, height) => {
  return "".concat((width / height).toFixed(2), " / 1");
};
const SliderPicture = _ref2 => {
  let {
    src,
    alt,
    imageIndex,
    height,
    width,
    imageSizes,
    breakpoints = {},
    dataCy
  } = _ref2;
  const imageTagSrcSize = imageSizes.medium || imageSizes.large || imageSizes.small;
  return /*#__PURE__*/_react.default.createElement("picture", {
    className: "keen-slider__slide",
    style: {
      minWidth: width + "px",
      maxWidth: width + "px",
      aspectRatio: calculateAspectRatio(width, height)
    }
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, imageSizes.large && /*#__PURE__*/_react.default.createElement("source", {
    media: "(min-width: ".concat(breakpoints.large, ")"),
    srcSet: createSrcSet(src, imageSizes.large)
  }), imageSizes.medium && /*#__PURE__*/_react.default.createElement("source", {
    media: "(min-width: ".concat(breakpoints.medium, ")"),
    srcSet: createSrcSet(src, imageSizes.medium)
  }), /*#__PURE__*/_react.default.createElement("source", {
    srcSet: createSrcSet(src, imageSizes.small || imageSizes.medium || imageSizes.large)
  }), /*#__PURE__*/_react.default.createElement("img", {
    loading: imageIndex === 0 ? "eager" : "lazy",
    src: "".concat(src, "?").concat(imageTagSrcSize["1x"]),
    srcSet: "".concat(src, "?").concat(imageTagSrcSize["2x"], " 2x"),
    width: width,
    height: height,
    alt: alt || "",
    "data-cy": dataCy
  })));
};
exports.SliderPicture = SliderPicture;
SliderPicture.propTypes = {
  /** Array of objects like { src: 'pathToImage' } */
  src: _propTypes.PropTypes.string,
  /** An index of image in a slider */
  imageIndex: _propTypes.PropTypes.number,
  /** Value for alt attribute */
  alt: _propTypes.PropTypes.string,
  /** initial height & width to keep aspect ratio */
  height: _propTypes.PropTypes.number,
  width: _propTypes.PropTypes.number,
  /** sizes object for media breakpoints uploads */
  imageSizes: _propTypes.PropTypes.object,
  /** optional, breakpoints on which to apply imageSizes */
  breakpoints: _propTypes.PropTypes.object,
  /** for Cypress */
  dataCy: _propTypes.PropTypes.string
};